"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaults_1 = require("./defaults");
class Model {
    constructor(data = { id: null }) {
        this.id = defaults_1.defaultString(data.id);
    }
    get isValid() {
        return this.id.length > 0;
    }
}
exports.default = Model;
